import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";

export default function Spinner({ className = "" }) {
  return <Loader2 className={cn("size-6 animate-spin text-foreground", className)} aria-hidden="true" />;
}
